module.exports = __webpack_public_path__ + "img/gear-web-app-gray@2x.c3155f31.png";